import { useEffect } from 'preact/hooks';

import WebApp from '@twa-dev/sdk';

import { GameOrientation } from '@/shared/api/game/types';
import { isDesktop } from '@/shared/helpers/is-desktop';

import { getOrientation } from '../../helpers/environment/get-orientation';

export const useLockOrientation = (gameOrientation: GameOrientation | undefined) => {
  useEffect(() => {
    if (isDesktop()) return;

    if (gameOrientation === GameOrientation.BOTH || !gameOrientation) {
      return;
    }

    const updateOrientation = () => {
      const orientation = getOrientation();

      if (orientation === gameOrientation) {
        WebApp.lockOrientation();
        window.removeEventListener('resize', updateOrientation);
      }
    };

    const orientation = getOrientation();

    if (orientation === gameOrientation) {
      WebApp.lockOrientation();
    } else {
      WebApp.unlockOrientation();
      window.addEventListener('resize', updateOrientation);
    }

    return () => window.removeEventListener('resize', updateOrientation);
  }, [gameOrientation]);
};
